import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotAuthorizedComponent} from './components/not-authorized/not-authorized.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'not-authorized',
    pathMatch: 'full'
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
    data: {title: 'Unauthorized User'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule {
}
